module.exports = __webpack_public_path__ + "static/image11-67d025ad6f1fc6ae9ab0d457f9079c43.jpeg";